import React from 'react';
import { useCart } from './CartContext';
import { useNavigate } from 'react-router-dom';
import './AutoStorePage.css';

const CartPage = () => {
  const { cart, removeFromCart, updateQty } = useCart();
  const navigate = useNavigate();
  const total = cart.reduce((sum, item) => sum + item.price * item.qty, 0);

  return (
    <main className="auto-store-main">
      <section className="auto-store-hero">
        <h1>Your Cart</h1>
      </section>
      <section className="auto-products-section">
        {cart.length === 0 ? (
          <p>Your cart is empty.</p>
        ) : (
          <ul className="auto-cart-list">
            {cart.map((item) => (
              <li key={item.id} className="auto-cart-item">
                <img src={item.image} alt={item.name} className="auto-cart-img" />
                <div className="auto-cart-info">
                  <span className="auto-cart-name">{item.name}</span>
                  <span className="auto-cart-price">${item.price}</span>
                  <input
                    type="number"
                    min="1"
                    value={item.qty}
                    onChange={(e) => updateQty(item.id, parseInt(e.target.value) || 1)}
                    className="auto-cart-qty"
                  />
                  <button className="auto-cart-remove" onClick={() => removeFromCart(item.id)}>
                    Remove
                  </button>
                </div>
              </li>
            ))}
          </ul>
        )}
        <div className="auto-cart-total" style={{marginTop: 24}}>
          <span>Total:</span>
          <span>${total}</span>
        </div>
        {cart.length > 0 && (
          <button className="auto-cart-checkout" style={{marginTop: 24}} onClick={() => navigate('/checkout')}>
            Checkout
          </button>
        )}
      </section>
    </main>
  );
};

export default CartPage; 